import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';

import { Group, Button, Text, Textarea } from '@mantine/core';
import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
import { stringDivider } from "../../utils/globalFunctions";

import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";

const ComponentNomorJemput = ({ stateData, utilsRef, fnCloseDrawer, fnSuccessBatal }) => {

    const mountedRef = React.useRef(true);

    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorSubmit: 'componentNomorJemput-1',
    })

    const canDeleteNota = [
        utils.penjemputanSteps.nota.value,
        utils.penjemputanSteps.segera_menjemput.value,
        utils.penjemputanSteps.sedang_menjemput.value,
        utils.penjemputanSteps.sudah_input_data.value,
    ];

    const [data, setData] = React.useState({
        batalModal: false,
        batalKeterangan: '',
        batalKeteranganError: '',
        batalLoadingSubmit: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const handleSubmit = () => {
        setData(d => ({ ...d, batalKeteranganError: '' }));

        if (validator.isEmpty(data.batalKeterangan, { ignore_whitespace: true })) {
            setData(d => ({ ...d, batalKeteranganError: 'Isi keterangan pembatalan.' }))
        } else {
            setData(d => ({ ...d, batalLoadingSubmit: true }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('trx_id', stateData.delivery_jemput_id);
            formDT.append('current_step', utilsRef.currentStep);
            formDT.append('is_cancel', utilsRef.isCancel);
            formDT.append('next_step', utils.penjemputanSteps.penjemputan_dibatalkan.value);
            formDT.append('keterangan', data.batalKeterangan);

            axios({
                method: 'post',
                url: BE_API_THREE + '/batalkan_trx_delivery_penjemputan',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, batalLoadingSubmit: false, batalModal: false }));

                if (response.data.flag_status === 'isset') {
                    fnSuccessBatal();
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorSubmit,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    fnCloseDrawer();

                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, batalLoadingSubmit: false, batalModal: false }));

                notifications.show({
                    id: notificationId.current.errorSubmit,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    return (
        <React.Fragment>
            <PaperWrapper stateMB="2rem">
                <Text size='sm' fw={500}>Nomor Penjemputan</Text>

                <Group position="apart" mt='.35rem'>
                    <Text size='sm'>
                        {stringDivider(stateData.delivery_jemput_id, [4, 6, 8], '.', '[Nomor Penjemputan]')}
                    </Text>

                    {canDeleteNota.includes(utilsRef.currentStep) &&
                        <Button
                            size="xs"
                            color="red"
                            variant='light'
                            onClick={() => setData(d => ({ ...d, batalModal: true }))}
                        >
                            Batal
                        </Button>
                    }
                </Group>
            </PaperWrapper>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.batalModal}
                fnHide={() => setData(d => ({ ...d, batalModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Batalkan'
                stateButtonActionPx='xs'
                stateButtonActionColor="red"
                stateButtonActionLoading={data.batalLoadingSubmit}
                fnButtonAction={handleSubmit}
            >
                <Textarea
                    value={data.batalKeterangan}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) => setData(d => ({ ...d, batalKeterangan: e.target.value }))}

                    mb='1rem'
                    label='Keterangan Pembatalan'
                    placeholder='Keterangan'
                    error={data.batalKeteranganError}
                    description=''
                    withAsterisk={true}
                />
            </ModalTakeAction>
        </React.Fragment>
    )
}

export default ComponentNomorJemput;